import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2de20ce2")

_pushScopeId("data-v-2de20ce2")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "message" }, " 項目の選択肢を追加して下さい。 ", -1)
const _hoisted_2 = { class: "item-frame" }
const _hoisted_3 = { class: "option-edit-row" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("選択肢 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("追加 ")
const _hoisted_6 = { class: "option-list-row" }
const _hoisted_7 = { class: "vue-flex-column list-buttons" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("上へ ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("下へ ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("削除 ")
const _hoisted_11 = { class: "button-frame" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("OK ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("キャンセル ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_normal_edit_box = _resolveComponent("normal-edit-box")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_list_box = _resolveComponent("list-box")
  const _component_white_backdrop = _resolveComponent("white-backdrop")

  return (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
    _createVNode(_component_white_backdrop, { show: _ctx.show }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", {
          class: ["frame", _ctx.$mq]
        }, [
          _hoisted_1,
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_normal_edit_box, {
                class: "option-edit-box",
                modelValue: _ctx.optionText,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.optionText = $event))
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_normal_button, {
                class: "add-button",
                state: "normal",
                disabled: _ctx.optionText==='',
                onClick: _ctx.onAddOption
              }, {
                default: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_list_box, {
                class: "option-list-box",
                title: "カルテ項目",
                items: _ctx.listBoxOptionItems,
                modelValue: _ctx.selectedOptionId,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedOptionId = $event)),
                size: 10
              }, null, 8, ["items", "modelValue"]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_normal_button, {
                  class: "list-button",
                  state: "normal",
                  disabled: _ctx.isFirst,
                  onClick: _ctx.upOption
                }, {
                  default: _withId(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_normal_button, {
                  class: "list-button",
                  state: "normal",
                  disabled: _ctx.isLast,
                  onClick: _ctx.downOption
                }, {
                  default: _withId(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_normal_button, {
                  class: "list-button",
                  state: "delete",
                  onClick: _ctx.deleteOption
                }, {
                  default: _withId(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_normal_button, {
              ref: "yes",
              type: "button",
              class: "button",
              state: "confirm",
              onClick: _ctx.onYes
            }, {
              default: _withId(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_normal_button, {
              type: "button",
              class: "button",
              state: "confirm",
              onClick: _ctx.onNo
            }, {
              default: _withId(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 2), [
          [_vShow, _ctx.show]
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})